export enum TabValues {
  TAB_GENERATE = 0,
  TAB_METRICS = 1,
  TAB_BATCHES = 2,
  TAB_REFERENCES = 3,
  TAB_FEEDBACK = 4,
  TAB_METADATA = 5,
}
